var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ff-item"},[_c('div',{staticClass:"ff-item-inner"},[_c('div',{staticClass:"ff-img",style:({'background-image': 'url('+ _vm.imgSrc + ')'})}),_vm._v(" "),_vm._t("mark")],2),_vm._v(" "),(_vm.name)?_c('p',{directives:[{name:"marquee",rawName:"v-marquee"}],staticClass:"ff-item-name"},[_c('span',[_vm._v(_vm._s(_vm.name))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caca806a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Item.vue
// module id = null
// module chunks = 